import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_ACADEMIC_INFO_GROUP_LIST_REQUEST = 'FETCH_ACADEMIC_INFO_GROUP_LIST_REQUEST';
export const FETCH_ACADEMIC_INFO_GROUP_LIST_SUCCESS = 'FETCH_ACADEMIC_INFO_GROUP_LIST_SUCCESS';
export const FETCH_ACADEMIC_INFO_GROUP_LIST_FAILURE = 'FETCH_ACADEMIC_INFO_GROUP_LIST_FAILURE';
export const FETCH_ACADEMIC_INFO_CONCERNS_STUDENT_SKILLS_REQUEST = 'FETCH_ACADEMIC_INFO_CONCERNS_STUDENT_SKILLS_REQUEST';
export const FETCH_ACADEMIC_INFO_CONCERNS_STUDENT_SKILLS_SUCCESS = 'FETCH_ACADEMIC_INFO_CONCERNS_STUDENT_SKILLS_SUCCESS';
export const FETCH_ACADEMIC_INFO_CONCERNS_STUDENT_SKILLS_FAILURE = 'FETCH_ACADEMIC_INFO_CONCERNS_STUDENT_SKILLS_FAILURE';


const buildAcademicInfoSummaryUrl = (isAllGroups) =>
  buildUrl(`/users/academic-info/my-groups?isAllGroups=${isAllGroups}`);

export function fetchAcademicInfoGroupListIfNeeded(isAllGroups) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildAcademicInfoSummaryUrl(isAllGroups) })) {
      return false;
    }

    return dispatch(fetchAcademicInfoGroupList(isAllGroups));
  };
}

export function fetchAcademicInfoGroupList(isAllGroups) {
  return (dispatch) => {
    const method = 'GET';
    const url = buildAcademicInfoSummaryUrl(isAllGroups);

    return dispatch(fetchAcademicInfoGroupListRequest()).payload
      .then((response) => dispatch(fetchAcademicInfoGroupListSuccess(response)))
      .catch((error) => dispatch(fetchAcademicInfoGroupListFailure(error)));

    function fetchAcademicInfoGroupListRequest() {
      return ApiCall.createAction({
        type: FETCH_ACADEMIC_INFO_GROUP_LIST_REQUEST,
        payload: fetch(url),
        method,
        url,
      });
    }

    function fetchAcademicInfoGroupListSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_ACADEMIC_INFO_GROUP_LIST_SUCCESS,
        payload: response,
        isAllGroups,
        method,
        url,
      });
    }

    function fetchAcademicInfoGroupListFailure(error) {
      return ApiCall.createAction({
        type: FETCH_ACADEMIC_INFO_GROUP_LIST_FAILURE,
        method,
        url,
        error,
      });
    }
  };
}

export function fetchAcademicInfoConcernsStudentSkills(scoresFrom, scoresTo) {
  return (dispatch) => {
    const method = 'GET';
    const url = buildUrl('/users/academic-info/concerns/student-skills?' +
        `scoresFrom=${scoresFrom}&` +
        `scoresTo=${scoresTo}`);

    return dispatch(fetchAcademicInfoConcernsStudentSkillsRequest()).payload
      .then((response) => dispatch(fetchAcademicInfoConcernsStudentSkillsSuccess(response)))
      .catch((error) => dispatch(fetchAcademicInfoConcernsStudentSkillsFailure(error)));

    function fetchAcademicInfoConcernsStudentSkillsRequest() {
      return ApiCall.createAction({
        type: FETCH_ACADEMIC_INFO_CONCERNS_STUDENT_SKILLS_REQUEST,
        payload: fetch(url),
        method,
        url,
      });
    }

    function fetchAcademicInfoConcernsStudentSkillsSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_ACADEMIC_INFO_CONCERNS_STUDENT_SKILLS_SUCCESS,
        payload: response,
        method,
        url,
      });
    }

    function fetchAcademicInfoConcernsStudentSkillsFailure(error) {
      return ApiCall.createAction({
        type: FETCH_ACADEMIC_INFO_CONCERNS_STUDENT_SKILLS_FAILURE,
        method,
        url,
        error,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/AcademicInfo/actions.js